import { Component, Input } from '@angular/core'
import { IconButtonComponent } from '@core/components/icon-button/icon-button.component'
import { ButtonComponent } from '@core/components/button/button.component'
import { IconComponent } from '@core/components/icon/icon.component'
import { OrderRead } from '@app/generated'
import { getOrderPatchFormConfig } from '@app/orders/functions/orders.utils'
import { Router } from '@angular/router'
import { config } from '@config'
import { LoaderService } from '@core/services/loader.service'
import { ModalService } from '@core/services/modal.service'
import { CorrespondenceWithClientForm } from '@app/orders/forms/correspondence-with-client/correspondence-with-client.form'
import { TooltipDirective } from '@core/directives/tooltip.directive'

@Component({
	selector: 'order-contractor-preview',
	standalone: true,
	templateUrl: './order-contractor-preview.component.html',
	styleUrl: './order-contractor-preview.component.scss',
	imports: [IconButtonComponent, ButtonComponent, IconComponent, TooltipDirective],
})
export class OrderContractorPreviewComponent {
	@Input() model: OrderRead = {} as OrderRead
	@Input() orderForm = getOrderPatchFormConfig()

	protected readonly textShowContractor = $localize`Show contractor`
	protected readonly textCustomerCorrespondence = $localize`Correspondence`

	constructor(
		private router: Router,
		private loaderService: LoaderService,
		private modalService: ModalService,
	) {}

	/**
	 * Handles the click event for contractor details.
	 * Navigates to the contractor's details page if the contractor ID is available.
	 */
	contractorDetailsClick(): void {
		const contractorId = this.model.entity?.id
		if (!contractorId) {
			return
		}
		this.loaderService.setCover().enable(() => {
			this.router.navigateByUrl(`${config.modules.contractors.path}/entity/${contractorId}`).then()
		})
	}

	/**
	 * Opens a modal for customer correspondence.
	 * The modal allows the user to view and manage correspondence with the customer.
	 * The loader service is used to show a loading indicator while the modal is being prepared.
	 */
	async openCustomerCorrespondenceModal() {
		this.loaderService.setContain().enable(async () => {
			const modal = await this.modalService.open<CorrespondenceWithClientForm>(CorrespondenceWithClientForm)
			modal.componentInstance.orderID = this.model.id
			modal.componentInstance.entityName = this.model.entity?.name ?? ''
			modal.title = $localize`Correspondence`
			modal.iconName = 'chat-square-dots'
			modal.width = '840px'
			modal.afterClosed.subscribe(value => {
				if (!value) {
					return
				}
				this.modalService.close()
				this.loaderService.disable()
			})
		})
	}
}
